import { Stack } from '@mui/material'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { IShopSchema } from '../../../../../shared/types'
import { currentAdminbusinessActions } from '../../../../../store/features/currentBusiness'
import { RootState } from '../../../../../store/store'
import spreadSheet from '../../../../../utils/spreadsheet'
import Modal from '../../../../molecules/Modal'
import AddNewShopForm from './forms/AddNewShopForm'
import ExportDataForm from './forms/ExportDataForm'
import Header from './PageHeader'
import Content from './page_content'
// import { selectUserPropsState } from '../../../../../store/features/user'



export default function Main() {

    const [isExportSalesmodalOpen, setIsExportSalesModalOpen] = useState(false)
    const [isCreateNewShopModalOpen, setIsCreateNewShopModalOpen] = useState(false)
    const dispatch = useDispatch()
    // const user_id = useSelector(selectUserPropsState)?.uid
    const business_shops = useSelector((state:RootState)=>state.currentBusiness.shops)
    const current_business_metadata = useSelector((state:RootState)=>state.currentBusiness.metaData)

    

    const handleOnExportSalesButtonClick =()=>{
        setIsExportSalesModalOpen(isExportSalesmodalOpen ? false : true)
    }
    const handleOnCreateNewShopButtonClick =()=>{
        setIsCreateNewShopModalOpen(isCreateNewShopModalOpen ? false : true)
    }

    const handleOnExport = (data:IShopSchema[])=>{

        if(data.length <= 0){
            toast("Error: No shops were created within the range you selected",{
                position: "top-center",
                type: "error",
                hideProgressBar: true,
                theme: "dark",
            })
            return
        }

        const rows = ["Shop name", "Date created", "Gross profit", "Gross revenue", "Items in stock", "Cash in shop"]
        const cols: (string|number|Date)[][] = [];

        data.forEach((shop)=>{
            const arr = [shop.name, shop.created_at as Date, shop.gross_profit, shop.gross_revenue, shop.items_in_stock, shop.cash_in_shop]
            cols.push(arr)
        })


        const aoa = [
            rows,
            ...cols
        ]

        spreadSheet.aoaToSpreadSheet(aoa, "Shops Data")
        setIsExportSalesModalOpen(false)
        
        
    }

    // const refresh = async ()=>{

    //     try {

    //         dispatch(currentAdminbusinessActions.setCurrentBusinessMetadata({}))
            
    //         const currentBusiness = await Business.getCurrentBusinessMetadata(user_id)
    //         dispatch(currentAdminbusinessActions.setCurrentBusinessMetadata({
    //             name: currentBusiness.name,
    //             total_shops: currentBusiness.stats.total_shops,
    //             best_performing_shop: currentBusiness.stats.best_performing_shop === null ? "Not yet available" : currentBusiness.stats.best_performing_shop,
    //             gross_revenue: currentBusiness.stats.gross_revenue,
    //             gross_profit: currentBusiness.stats.gross_profit,
    //             total_sales: currentBusiness.stats.total_sales
    //         }))

    //         return
            
    //     } catch (error) {
    //         throw error
    //     }
        
    // }

    

    return (
        <Stack
            direction="column"
            spacing={2}
        >

            <Header onNewShopBtnClick={handleOnCreateNewShopButtonClick} onExportSalesBtnClick={handleOnExportSalesButtonClick} />
            <Content />

            {/* Export sales modal */}
            <Modal
                title="Export sales history"
                subtitle="Select time range to export data"
                visible={isExportSalesmodalOpen}
                setVisibility={setIsExportSalesModalOpen}
            >
                <ExportDataForm 
                    onDone={handleOnExport}
                    onFail={(error)=>{
                        toast(error,{
                            type:"error",
                            hideProgressBar: true,
                            theme: "dark",
                            position: "top-center"
                        })
                    }}
                />
            </Modal>

            {/* Add new shop modal */}
            <Modal
                title="New shop"
                subtitle="Please complete the form to create a new shop."
                visible={isCreateNewShopModalOpen}
                setVisibility={setIsCreateNewShopModalOpen}
            >
                <AddNewShopForm
                    onSubmit={async(new_shop)=>{
                        setIsCreateNewShopModalOpen(false)
                        dispatch(currentAdminbusinessActions.setCurrentBusinessShops([
                            ...business_shops!,
                            new_shop
                        ]))
                        dispatch(currentAdminbusinessActions.setCurrentBusinessMetadata({
                            ...current_business_metadata,
                            total_shops: current_business_metadata!.total_shops + 1
                        }))
                        toast('Shop created successfully.', {
                            type: "success",
                            hideProgressBar: true,
                            theme: "dark",
                            position: "top-center"
                        })
                        
                    }}
                    onSubmitFail={()=>{}}
                />
            </Modal>


        </Stack>
    )

}

